import { postRequest } from './ApiService';

// POST /api/account/contact-support/
// See guidance/contact-support-fe-guide.md for the full BE contract.
//
// Returns a Promise that resolves to { sent: boolean } on success or
// rejects with the superagent error (err.status is the HTTP status,
// err.response.body carries the DRF error shape for 400s and the
// { detail } string for 429s).
export const submitSupportMessage = ({ subject, message }) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  return postRequest(`${apiUrl}account/contact-support/`)
    .send({ subject, message })
    .then((res) => (res && res.body) || { sent: false });
};



// WEBPACK FOOTER //
// ./src/api/ContactSupport.js